import React from 'react';
import { useTranslation } from './TranslationContext';

const LanguageSwitcher = () => {
  const { changeLanguage, currentLanguage } = useTranslation();

  const handleLanguageChange = () => {
    const newLanguage = currentLanguage === 'fr' ? 'en' : 'fr';
    changeLanguage(newLanguage);
  };

  return (
    <button
      onClick={handleLanguageChange}
      style={{
        margin: '1px',
        border: '3px solid #1e5fa8',
        backgroundColor: '#178cc2',
        color: 'white',
        fontSize: '18px',
        fontFamily: 'Leckerli One',
        fontWeight: '400',
        padding: '7px',
        marginTop: '5px',
        marginBottom: '5px',
        marginLeft: '5px',
        textShadow: '0px 1px 1px rgb(11, 11, 11), 0 0 0.8em white, 0 0 0.1em rgb(18, 17, 17)',
        boxShadow: '0 0 12px 2px #0d68c3',
        borderRadius: '30px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
      }}

    >
      {currentLanguage === 'fr' ? 'English' : 'Français'}
    </button>
  );
};

export default LanguageSwitcher;


